<template>
  <v-app>
    <!-- <v-img
      :src="require('@/assets/logo.png')"
      class="mx-auto"
      max-height="220"
      max-width="220"
    /> -->
    <v-container>
      <v-row class="mt-8">
        <v-col>
          <v-card width="400px" class="mx-auto pb-2">
            <v-form ref="form" @submit.prevent="onClicklogin">
              <v-card-title>ログイン</v-card-title>
              <v-card-text>
                <!-- <v-alert :type="alertType" dismissible v-model="showAlert">{{ alertMessage }}</v-alert> -->
                <v-alert :type="alertType" dismissible v-model="showAlert"><div v-html="alertMessage"></div></v-alert>
                <v-row>
                  <!-- ログインID -->
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="loginId"
                      label="ログインID"
                      append-icon="mdi-account-circle"
                      hint="ログインIDを入力してください。"
                      :rules="rulesLoginId"
                      :disabled="newPasswordRequired"
                      ref="loginId"
                    >
                    </v-text-field>
                  </v-col>
                  <!-- パスワード -->
                  <v-col cols="12" sm="12" v-if="!newPasswordRequired">
                    <v-text-field
                      v-model="password"
                      label="パスワード"
                      :append-icon="isPassVisible ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="() => (isPassVisible = !isPassVisible)"
                      :type="isPassVisible ? 'text' : 'password'"
                      :rules="rulesPassword"
                    >
                    </v-text-field>
                  </v-col>
                  <!-- 新パスワード -->
                  <v-col cols="12" sm="12" v-if="newPasswordRequired">
                    <v-text-field
                      v-model="newPassword"
                      label="新パスワード"
                      :append-icon="isNewPassVisible ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="() => (isNewPassVisible = !isNewPassVisible)"
                      :type="isNewPassVisible ? 'text' : 'password'"
                      :rules="rulesNewPassword"
                    >
                    </v-text-field>
                  </v-col>
                  <!-- パスワード（確認） -->
                  <v-col cols="12" sm="12" v-if="newPasswordRequired">
                    <v-text-field
                      v-model="confirmPassword"
                      label="パスワード（確認）"
                      :append-icon="isNewPassConfirmVisible ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="() => (isNewPassConfirmVisible = !isNewPassConfirmVisible)"
                      :type="isNewPassConfirmVisible ? 'text' : 'password'"
                      :rules="rulesNewPassword"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-divider class="mt-5"></v-divider>
              </v-card-text>
              <v-card-actions class="justify-center">
                <!-- ログイン -->
                <v-btn color="secondary" type="submit" large rounded class="my-2">
                  <v-icon left> mdi-login </v-icon>ログイン
                </v-btn>
              </v-card-actions>
              <v-card-actions class="justify-center">
                <!-- キャンセル -->
                <v-btn color="warning" large rounded @click="initialize" v-if="newPasswordRequired">
                  <v-icon left> mdi-close </v-icon>キャンセル
                </v-btn>
              </v-card-actions>
            </v-form>
            <v-card-actions class="justify-center" v-show="!newPasswordRequired">
              <PasswordResetDialog />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import PasswordResetDialog from '@/components/dialog/PasswordResetDialog';
import { Auth } from 'aws-amplify';
import { addLog } from '@/assets/js/logger';
import { messageKeys } from '@/assets/js/logger/logMessages';
import { clientMessageKeys, getClientMessage } from '@/assets/js/clientMessages';
import { setUserData } from '@/assets/js/aws/cache';
import { RULE_LIST } from '@/assets/js/validation';
import { validationMixin } from '@/mixin/validation';
import { loadingMixin } from '@/mixin/loading';
export default {
  name: 'Login',
  components: { PasswordResetDialog },
  mixins: [validationMixin, loadingMixin],
  data: () => ({
    // ログインID
    loginId: '',
    // パスワード
    password: '',
    isPassVisible: false,
    isNewPassVisible: false,
    isNewPassConfirmVisible: false,
    // パスワード変更
    newPasswordRequired: false,
    newPassword: '',
    confirmPassword: '',
    // 入力チェック
    rules: RULE_LIST,
    // アラートタイプ
    alertType: null,
    // アラートメッセージ
    alertMessage: null,
    // アラート表示フラグ
    showAlert: false,
  }),
  computed: {
    rulesLoginId() {
      if (this.newPasswordRequired) {
        return [];
      }
      return [this.rules.required, this.rules.loginIdLength];
    },
    rulesPassword() {
      if (this.newPasswordRequired) {
        return [];
      }
      return [this.rules.required, this.rules.passwordLength];
    },
    rulesNewPassword() {
      if (this.newPasswordRequired) {
        return [this.rules.required, this.rules.minLength, this.rules.containsNumber, this.rules.containsLowercase];
        //return [this.rules.required, this.rules.passwordLength];
      }
      return [];
    },
  },
  mounted() {
    // アイコンのtabindexを-1に設定
    this.disableTabIndex();
    // バリデーションエラーをリセット
    this.$refs.form.resetValidation();
    // 初期化処理
    this.initialize();
    // ローディングエフェクトOFF
    this.$_setLoading(false);
  },
  methods: {
    // ログインボタン
    async onClicklogin() {
      this.showAlert = false;
      // 入力チェック
      if (!this.$_validate()) {
        return;
      }
      // ローディングエフェクトON
      this.$_setLoading(true);
      const result = await this.signIn();
      if (!result) this.$_setLoading(false);
    },
    /**
     * ログインボタン押下時処理
     */
    async signIn() {
      const functionName = 'signIn';

      try {
        let user = await Auth.signIn(this.loginId, this.password);

        // 初回パスワード変更が必要な場合
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          if (this.newPasswordRequired) {
            // 初回パスワード変更
            if (!(await this.initialPasswordChange(user))) return false;
          } else {
            // アラート表示（「初期パスワードを変更する必要があります。新しいパスワードを入力してください」）
            this.showClientAlert(clientMessageKeys.W0010);

            this.newPasswordRequired = true;
            this.confirmPassword = '';
            return false;
          }
        }

        // ユーザーデータをキャッシュ
        let userJudge = await setUserData(user.username);
        if (userJudge) {
          // 正常系操作ログの登録
          addLog({
            messageKey: messageKeys.I1003,
            component: this.$options.name,
            func: functionName,
            param: { loginId: user.username },
          });
          // ホーム画面に遷移
          this.$router.push('/');
          return true;
        } else {
          // アラート表示（「ユーザーテーブルにデータがありません」）
          this.showClientAlert(clientMessageKeys.E0010);
          // 異常系操作ログの登録
          addLog({
            messageKey: messageKeys.E3018,
            component: this.$options.name,
            func: functionName,
            param: { api: 'setUserData', loginId: user.username },
          });
          await Auth.signOut();
          return false;
        }
      } catch (error) {
        if (error.code) {
          console.log(error.code);
          switch (error.code) {
            case 'UserNotFoundException':
            case 'NotAuthorizedException':
            case 'InvalidParameterException':
              // アラート表示（「ユーザーIDかパスワードが正しくありません」）
              this.showClientAlert(clientMessageKeys.E0011);
              break;
            default: {
              // 異常系操作ログの登録
              addLog({
                messageKey: messageKeys.E3001,
                component: this.$options.name,
                func: functionName,
                param: { loginId: this.loginId, password: this.password },
                errorObject: error,
              });
              // アラート表示（「認証エラーが発生しました」）
              this.showClientAlert(clientMessageKeys.E0012);
              break;
            }
          }
        }
        return false;
      }
    },
    /**
     * 初回パスワード変更処理
     * @param {*} user
     */
    async initialPasswordChange(user) {
      const functionName = 'initialPasswordChange';
      if (this.newPassword !== this.confirmPassword) {
        // アラート表示（「同じパスワードを入力してください」）
        this.showClientAlert(clientMessageKeys.W0011);
        return false;
      }
      if (this.password === this.newPassword) {
        // アラート表示（「新しいパスワードは変更前のパスワードと異なるパスワードである必要があります」）
        this.showClientAlert(clientMessageKeys.W0012);
        return false;
      }
      // コメント
      try {
        await Auth.completeNewPassword(user, this.newPassword);
        return true;
      } catch (error) {
        console.log('error completeNewPassword', error);
        if (error.code) {
          switch (error.code) {
            case 'InvalidPasswordException':
              // アラート表示（「パスワードは数字、アルファベットの大文字・小文字、記号を含んだ8文字以上の文字列を設定してください」）
              this.showClientAlert(clientMessageKeys.E0013);
              break;
            default:
              // 異常系操作ログの登録
              addLog({
                messageKey: messageKeys.E3001,
                component: this.$options.name,
                func: functionName,
                param: {
                  api: 'completeNewPassword',
                  type: 'undefined',
                  loginId: this.loginId,
                },
                errorObject: error,
              });
              // アラート表示（「認証エラーが発生しました」）
              this.showClientAlert(clientMessageKeys.E0012);
              break;
          }
        }
        return false;
      }
    },
    /**
     * アイコンのtabindexを-1に設定
     */
    disableTabIndex() {
      const elements = document.getElementsByClassName('v-icon--link');
      for (const element of elements) {
        element.tabIndex = -1;
      }
    },
    /**
     * 初期化
     */
    initialize() {
      this.showAlert = false;
      this.newPasswordRequired = false;
      this.loginId = '';
      this.password = '';
      this.newPassword = '';
      this.confirmPassword = '';
      this.$vuetify.goTo(0);
      this.$refs.loginId.focus();
    },
    /**
     * アラート表示
     */
    showClientAlert(msgKey) {
      const { alertType, message } = getClientMessage(msgKey);

      this.alertType = alertType;
      this.alertMessage = message;
      this.showAlert = true;
      this.$vuetify.goTo(0);
    },
  },
};
</script>
